import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPatch } from "../api/client";

interface FollowingResponse {
  tournamentId: string;
  following: boolean;
}

export function TournamentFollowButton({ tournamentId, following }: { tournamentId: string; following: boolean }) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () => apiPatch<FollowingResponse>(`/api/v1/tournaments/${tournamentId}/following`, { following: !following }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["results-feed"] }),
        queryClient.invalidateQueries({ queryKey: ["tournaments"] }),
        queryClient.invalidateQueries({ queryKey: ["tournament"] }),
      ]);
    },
  });

  return <button className="following-state" type="button" disabled={mutation.isPending} onClick={() => mutation.mutate()}>
    {mutation.isPending ? "Saving…" : following ? "Following ★" : "Follow ☆"}
  </button>;
}
